"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStackedBarChartOptions = void 0;
var _color = require("../../styles/variables/_color");
var _charts = require("./charts");
var _helpers = require("./helpers");
const getStackedBarChartOptions = () => ({
  ..._charts.commonChartOptions,
  chart: {
    ..._charts.commonChartOptions.chart,
    type: 'bar'
  },
  legend: {
    ..._charts.commonChartOptions.legend,
    ..._helpers.bottomLegendRow,
    symbolWidth: 18
  },
  xAxis: {
    ..._charts.commonChartOptions.xAxis,
    labels: {
      style: _helpers.xAxisLabelStyle
    },
    title: {
      margin: 12,
      style: _helpers.xAxisTitleStyle
    },
    lineColor: _color.colorBorderPrimary
  },
  yAxis: {
    labels: {
      align: 'right',
      distance: 12,
      style: _helpers.yAxisLabelStyle
    },
    title: {
      margin: 12,
      style: _helpers.yAxisTitleStyle
    }
  },
  drilldown: {
    activeAxisLabelStyle: _helpers.activeLabelStyle,
    activeDataLabelStyle: _helpers.activeLabelStyle,
    breadcrumbs: {
      floating: true
    }
  }
});
exports.getStackedBarChartOptions = getStackedBarChartOptions;